
import apiClient from "../helpers/apiClient";

const API = `/api/v2/resto`
const api = apiClient();
const buildStatsPath = (metric, restoId) =>
  restoId ? `${API}/stats/${restoId}/${metric}` : `${API}/stats/${metric}`;

export const getRestoByHostId = () => api.get(`${API}/host`);
export const getRestoByAdminId = () => api.get(`${API}/admin`);

export const getCountHostByPlaceId = (restoId) => api.get(buildStatsPath("host", restoId));
export const getCountryByPlaceId = (restoId) => api.get(buildStatsPath("country", restoId));
export const getPositionRankingByPlaceId = (restoId) => api.get(buildStatsPath("position", restoId));
export const getNotifyByPlaceId = (restoId) => api.get(buildStatsPath("notify", restoId));
export const getLikeByPlaceId = (restoId) => api.get(buildStatsPath("likes", restoId));
